"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableColumnHeaderBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_data_table_config_interface_1 = require("./bc-data-table-config-interface");
var bc_data_table_constants_1 = require("./bc-data-table-constants");
var helpers_1 = require("../../../common/helpers");
var bc_tooltip_behavior_1 = require("../../molecules/bc-tooltip/bc-tooltip-behavior");
var BcDataTableColumnHeaderBehavior = (function () {
    function BcDataTableColumnHeaderBehavior(bcDataTableConfig, bcDataTableTBodyBehavior, bcDataTableMulticheckBehavior) {
        this.bcDataTableConfig = bcDataTableConfig;
        this.bcDataTableTBodyBehavior = bcDataTableTBodyBehavior;
        this.bcDataTableMulticheckBehavior = bcDataTableMulticheckBehavior;
        this.bcDataTableColumnHeader = this.bcDataTableConfig.columnHeaders;
    }
    BcDataTableColumnHeaderBehavior.prototype.createHtmlTableThead = function () {
        var _this = this;
        var newRow = document.createElement(common_constants_1.BcCommonConstants.TR_TAG);
        this.setSort(this.bcDataTableColumnHeader.data, this.bcDataTableColumnHeader);
        this.bcDataTableColumnHeader.data.forEach(function (columnHeader) {
            var newThCell = columnHeader.dataType === bc_data_table_constants_1.BcDataTableConstansts.DATA_TYPE_CHECKALL
                ? _this.createTheadCheckAllCell()
                : _this.createTheadCell(columnHeader, _this.bcDataTableColumnHeader);
            newThCell.setAttribute(common_constants_1.BcCommonConstants.SCOPE, common_constants_1.BcCommonConstants.COL);
            newRow.appendChild(newThCell);
        });
        return newRow;
    };
    BcDataTableColumnHeaderBehavior.prototype.renderTableHead = function (dataTable) {
        if (this.bcDataTableConfig.columnHeaders) {
            dataTable.tHead.innerHTML = '';
            var newTheadRow = this.createHtmlTableThead();
            dataTable.tHead.appendChild(newTheadRow);
        }
    };
    BcDataTableColumnHeaderBehavior.prototype.reset = function (dataTable, removeSort) {
        if (removeSort === void 0) { removeSort = true; }
        if (this.bcDataTableConfig.columnHeaders) {
            if (removeSort) {
                this.bcDataTableConfig.columnHeaders.data.map(function (item) { return (__assign(__assign({}, item), { sort: null })); });
            }
            this.renderTableHead(dataTable);
        }
    };
    BcDataTableColumnHeaderBehavior.prototype.addThStickyClass = function (dataTable) {
        this.removeThStickyClass(dataTable);
        var theadCells = dataTable.querySelectorAll(common_constants_1.BcCommonConstants.TH_TAG);
        if (this.bcDataTableConfig.multicheck) {
            theadCells[0].classList.add(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_CLASS);
            theadCells[1].classList.add(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_WITH_CHECK_CLASS);
            theadCells[1].classList.add(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_CLASS_SHADOW);
        }
        else {
            theadCells[0].classList.add(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_CLASS);
            theadCells[0].classList.add(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_CLASS_SHADOW);
        }
    };
    BcDataTableColumnHeaderBehavior.prototype.removeThStickyClass = function (dataTable) {
        var theadCells = dataTable.querySelectorAll(common_constants_1.BcCommonConstants.TH_TAG);
        if (theadCells.length > 0) {
            theadCells[0].classList.remove(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_CLASS);
            theadCells[0].classList.remove(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_CLASS_SHADOW);
            theadCells[1].classList.remove(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_WITH_CHECK_CLASS);
            theadCells[1].classList.remove(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_CLASS_SHADOW);
        }
    };
    BcDataTableColumnHeaderBehavior.prototype.createTheadCheckAllCell = function () {
        var newThCell = document.createElement(common_constants_1.BcCommonConstants.TH_TAG);
        var CheckAllDivContainer = this.createDivElement(bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_CHECK_ALL_DIV_CONTAINER);
        newThCell.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CHECKBOX_MULTICHECK_THEAD_CLASS);
        var checkboxThead = this.bcDataTableMulticheckBehavior.getTheadCheckbox();
        checkboxThead.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CHECKBOX_THEAD_CLASS);
        CheckAllDivContainer.appendChild(checkboxThead);
        newThCell.style.width = bc_data_table_constants_1.BcDataTableConstansts.W_50_PX;
        newThCell.appendChild(CheckAllDivContainer);
        return newThCell;
    };
    BcDataTableColumnHeaderBehavior.prototype.setMultiCheck = function () {
        if (this.bcDataTableColumnHeader.data[0].dataType !== 'checkAll') {
            var newArrayElement = { dataType: 'checkAll', name: '', value: false };
            this.bcDataTableColumnHeader.data.unshift(newArrayElement);
        }
    };
    BcDataTableColumnHeaderBehavior.prototype.setSort = function (bcDataTableThCell, bcDataTableColumnHeader) {
        if (bcDataTableColumnHeader.sort) {
            bcDataTableThCell.forEach(function (thCell) {
                thCell.sort = thCell.sort || null;
            });
        }
    };
    BcDataTableColumnHeaderBehavior.prototype.createTheadCell = function (columnHeader, bcDataTableColumnHeader) {
        var _this = this;
        var thCell = document.createElement(common_constants_1.BcCommonConstants.TH_TAG);
        thCell.classList.add(bc_data_table_config_interface_1.BcDataTypeClassMap[columnHeader.dataType]);
        thCell.classList.add(bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_CLASS);
        var divContainer = this.createThDivContainer();
        if (columnHeader.dataType !== bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_DATATYPE_ACTIONS) {
            this.addAccesibleAction(divContainer);
            (0, helpers_1.addFocusable)(divContainer, { tabindex: '0' });
            this.createTitle(columnHeader, divContainer);
            this.createIconInfo(columnHeader, divContainer);
            divContainer.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, this.handleOrderHeaderClick.bind(this));
            this.createIconOrder(bcDataTableColumnHeader, divContainer, columnHeader);
            this.setWidth(thCell, columnHeader);
            setTimeout(function () {
                _this.addTooltipInTitle(divContainer);
            }, bc_data_table_constants_1.BcDataTableConstansts.WINDOW_RESIZE_TIMEOUT);
        }
        thCell.appendChild(divContainer);
        if (bcDataTableColumnHeader.separation) {
            thCell.classList.add(bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_CLASS + '-' + bcDataTableColumnHeader.separation);
        }
        return thCell;
    };
    BcDataTableColumnHeaderBehavior.prototype.checkTooltipInTitle = function (dataTable) {
        var _this = this;
        var thead = dataTable.querySelector(common_constants_1.BcCommonConstants.THEAD_TAG);
        if (thead) {
            var columnHeaderDivsContainer = Array.from(thead.getElementsByClassName(bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_TITLE_DIV_CONTAINER));
            columnHeaderDivsContainer.forEach(function (columnHeaderDivContainer) {
                _this.addTooltipInTitle(columnHeaderDivContainer);
            });
        }
    };
    BcDataTableColumnHeaderBehavior.prototype.clearTooltipContainers = function () {
        var elements = document.getElementsByClassName(bc_data_table_constants_1.BcDataTableConstansts.TOOLTIP_CONTAINER_CLASS);
        Array.from(elements).forEach(function (element) {
            element.remove();
        });
    };
    BcDataTableColumnHeaderBehavior.prototype.addTooltipAttributes = function (columnHeaderDiv) {
        columnHeaderDiv.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.TOOLTIP_CLASS, '');
        columnHeaderDiv.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.TOOLTIP_ATTR_TEXT, columnHeaderDiv.innerText);
        columnHeaderDiv.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.TOOLTIP_ATTR_POSITION, bc_data_table_constants_1.BcDataTableConstansts.ATTR_POSITION_BOTTOM);
        columnHeaderDiv.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTR_TABINDEX, bc_data_table_constants_1.BcDataTableConstansts.ATTR_TABINDEX_NEGATIVE + common_constants_1.COMMON_CONSTANTS_NUMBERS.N0.toString());
        columnHeaderDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.TOOLTIP_CLASS);
        columnHeaderDiv.textContent = columnHeaderDiv.innerText;
    };
    BcDataTableColumnHeaderBehavior.prototype.removeTooltipAttributes = function (columnHeaderDiv) {
        columnHeaderDiv.removeAttribute(bc_data_table_constants_1.BcDataTableConstansts.TOOLTIP_CLASS);
        columnHeaderDiv.removeAttribute(bc_data_table_constants_1.BcDataTableConstansts.TOOLTIP_ATTR_TEXT);
        columnHeaderDiv.removeAttribute(bc_data_table_constants_1.BcDataTableConstansts.TOOLTIP_ATTR_POSITION);
        columnHeaderDiv.removeAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTR_TABINDEX);
        columnHeaderDiv.classList.remove(bc_data_table_constants_1.BcDataTableConstansts.TOOLTIP_CLASS);
    };
    BcDataTableColumnHeaderBehavior.prototype.removeTooltipContainersWithMatchingText = function (columnHeaderDiv) {
        var elements = document.getElementsByClassName(bc_data_table_constants_1.BcDataTableConstansts.TOOLTIP_CONTAINER_CLASS);
        Array.from(elements).forEach(function (element) {
            var paragraph = element.querySelector(common_constants_1.BcCommonConstants.P_TAG);
            if (paragraph && paragraph.textContent.includes(columnHeaderDiv.innerText)) {
                element.remove();
            }
        });
    };
    BcDataTableColumnHeaderBehavior.prototype.addTooltipInTitle = function (divContainer) {
        var columnHeaderDiv = divContainer.getElementsByClassName(bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_TITLE_DIV)[0];
        var isEllipsisActive = columnHeaderDiv.scrollHeight > columnHeaderDiv.clientHeight;
        this.clearTooltipContainers();
        if (isEllipsisActive) {
            this.addTooltipAttributes(columnHeaderDiv);
        }
        else {
            this.removeTooltipAttributes(columnHeaderDiv);
            this.removeTooltipContainersWithMatchingText(columnHeaderDiv);
        }
        bc_tooltip_behavior_1.BcTooltipBehavior.setUpAll();
    };
    BcDataTableColumnHeaderBehavior.prototype.setWidth = function (thCell, columnHeader) {
        var columnsWithoutWidth = this.bcDataTableColumnHeader.data.length;
        var totalPercent = this.getPercent();
        if (bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_DATATYPE_MULTICHECK in this.bcDataTableConfig &&
            this.bcDataTableConfig.multicheck) {
            columnsWithoutWidth--;
        }
        if (bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_DATATYPE_ACTIONS in this.bcDataTableConfig) {
            columnsWithoutWidth--;
        }
        var columnsWithWidth = this.bcDataTableColumnHeader.data.filter(function (column) { return column.hasOwnProperty('width'); });
        var width = (bc_data_table_constants_1.BcDataTableConstansts.N_100 - totalPercent) / (columnsWithoutWidth - columnsWithWidth.length);
        if (columnHeader.width) {
            thCell.style.width = String(columnHeader.width + bc_data_table_constants_1.BcDataTableConstansts.PERCENT);
        }
        else {
            thCell.style.width = String(width + bc_data_table_constants_1.BcDataTableConstansts.PERCENT);
        }
    };
    BcDataTableColumnHeaderBehavior.prototype.getPercent = function () {
        return this.bcDataTableColumnHeader.data.reduce(function (total, columnHeader) {
            if (columnHeader.width !== undefined) {
                return total + columnHeader.width;
            }
            else {
                return total;
            }
        }, 0);
    };
    BcDataTableColumnHeaderBehavior.prototype.addAccesibleAction = function (divContainer) {
        var _this = this;
        divContainer.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            var keyCode = event['code'];
            if (keyCode === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE || keyCode === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER) {
                _this.handleOrderHeaderClick(event);
            }
        });
    };
    BcDataTableColumnHeaderBehavior.prototype.createDivElement = function (cssClass) {
        var container = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        container.classList.add(cssClass);
        return container;
    };
    BcDataTableColumnHeaderBehavior.prototype.createThDivContainer = function () {
        return this.createDivElement(bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_DIV_CONTAINER);
    };
    BcDataTableColumnHeaderBehavior.prototype.createTitle = function (columnHeader, divContainer) {
        var titleDivContainer = this.createDivElement(bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_TITLE_DIV_CONTAINER);
        var alignmentClasses = {
            left: bc_data_table_constants_1.BcDataTableConstansts.FLEX_ALIGN_LEFT,
            center: bc_data_table_constants_1.BcDataTableConstansts.FLEX_ALIGN_CENTER,
            right: bc_data_table_constants_1.BcDataTableConstansts.FLEX_ALIGN_RIGHT,
        };
        if (columnHeader.align && alignmentClasses[columnHeader.align]) {
            titleDivContainer.classList.add(alignmentClasses[columnHeader.align]);
        }
        var titleLabel = this.createDivElement(bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_TITLE_DIV);
        titleLabel.textContent = columnHeader.name;
        titleDivContainer.appendChild(titleLabel);
        divContainer.appendChild(titleDivContainer);
    };
    BcDataTableColumnHeaderBehavior.prototype.createIconOrder = function (bcDataTableColumnHeader, divContainer, columnHeader) {
        var iconDivContainter = this.createDivElement(bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_ICON_ORDER_CONTAINER);
        if (bcDataTableColumnHeader.sort) {
            this.addSortIcon(iconDivContainter);
            if ((columnHeader === null || columnHeader === void 0 ? void 0 : columnHeader.align) === bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_ALIGN_RIGHT) {
                divContainer.prepend(iconDivContainter);
            }
            else {
                divContainer.appendChild(iconDivContainter);
            }
        }
    };
    BcDataTableColumnHeaderBehavior.prototype.createIconInfo = function (columnHeader, divContainer) {
        var iconDivContainter = this.createDivElement(bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_ICON_INFO_CONTAINER);
        var titleDivContainer = divContainer.getElementsByClassName(bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_TITLE_DIV_CONTAINER)[0];
        if (columnHeader.tooltip) {
            this.addInfoIcon(iconDivContainter, columnHeader.tooltip);
            titleDivContainer.appendChild(iconDivContainter);
        }
    };
    BcDataTableColumnHeaderBehavior.prototype.addSortIcon = function (sortCell) {
        var iconElement = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        iconElement.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS);
        iconElement.innerHTML = bc_data_table_constants_1.BcDataTableConstansts.ICON_ORDER_NULL;
        iconElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.ORDER_ICON_EM);
        sortCell.appendChild(iconElement);
    };
    BcDataTableColumnHeaderBehavior.prototype.addInfoIcon = function (sortCell, tooltipText) {
        var iconElement = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        iconElement.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS);
        iconElement.innerHTML = bc_data_table_constants_1.BcDataTableConstansts.ICON_INFO;
        iconElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.TOOLTIP_CLASS, '');
        iconElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.TOOLTIP_ATTR_TEXT, tooltipText);
        iconElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.TOOLTIP_ATTR_POSITION, bc_data_table_constants_1.BcDataTableConstansts.ATTR_POSITION_BOTTOM);
        iconElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTR_TABINDEX, bc_data_table_constants_1.BcDataTableConstansts.ATTR_TABINDEX_NEGATIVE + common_constants_1.COMMON_CONSTANTS_NUMBERS.N0.toString());
        iconElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.TOOLTIP_CLASS);
        sortCell.appendChild(iconElement);
    };
    BcDataTableColumnHeaderBehavior.prototype.checkOverflowAfterSort = function (dataTable) {
        var divContainer = dataTable.closest(common_constants_1.BcCommonConstants.DIV_TAG);
        if (divContainer.scrollWidth > divContainer.clientWidth) {
            this.addThStickyClass(dataTable);
            this.bcDataTableTBodyBehavior.addBodyStickyClass(dataTable);
        }
        else {
            this.removeThStickyClass(dataTable);
            this.bcDataTableTBodyBehavior.removeBodyStickyClass(dataTable);
        }
    };
    BcDataTableColumnHeaderBehavior.prototype.handleOrderHeaderClick = function (event) {
        var _a;
        if (!((_a = this.bcDataTableConfig.columnHeaders) === null || _a === void 0 ? void 0 : _a.sort)) {
            return false;
        }
        var clickedDivContainer = event.target;
        var clickedTh = clickedDivContainer.closest(common_constants_1.BcCommonConstants.TH_TAG);
        var index = clickedTh.cellIndex;
        var thead = clickedTh.closest(common_constants_1.BcCommonConstants.THEAD_TAG);
        var dataTable = thead.closest(common_constants_1.BcCommonConstants.TABLE_TAG);
        var thCell = Array.from(thead.querySelectorAll(common_constants_1.BcCommonConstants.TH_TAG))[index];
        var sort = this.cleanSortState(index);
        this.updateOrderClass(thead, thCell, sort);
        this.updateIcon(thead, thCell, sort);
        this.bcDataTableTBodyBehavior.updateHtmlTableRowBySortIndex(dataTable, index);
        this.checkOverflowAfterSort(dataTable);
    };
    BcDataTableColumnHeaderBehavior.prototype.updateIcon = function (thead, thCell, sort) {
        var thCells = Array.from(thead.querySelectorAll(common_constants_1.BcCommonConstants.TH_TAG));
        thCells.forEach(function (cell) {
            var previusEmIcon = cell.getElementsByClassName(bc_data_table_constants_1.BcDataTableConstansts.ORDER_ICON_EM)[0];
            if (previusEmIcon) {
                previusEmIcon.textContent = bc_data_table_constants_1.BcDataTableConstansts.ICON_ORDER_NULL;
            }
        });
        var emIcon = thCell.getElementsByClassName(bc_data_table_constants_1.BcDataTableConstansts.ORDER_ICON_EM)[0];
        if (sort === 'asc') {
            emIcon.textContent = bc_data_table_constants_1.BcDataTableConstansts.ICON_ORDER_ASC;
        }
        else {
            emIcon.textContent = bc_data_table_constants_1.BcDataTableConstansts.ICON_ORDER_DES;
        }
    };
    BcDataTableColumnHeaderBehavior.prototype.updateOrderClass = function (thead, thCell, sort) {
        this.removeOrderClasses(thead);
        if (sort === 'asc') {
            thCell.classList.add(bc_data_table_constants_1.BcDataTableConstansts.ORDER_ASC_CLASS);
        }
        else {
            thCell.classList.add(bc_data_table_constants_1.BcDataTableConstansts.ORDER_DES_CLASS);
        }
    };
    BcDataTableColumnHeaderBehavior.prototype.removeOrderClasses = function (thead) {
        var thCells = Array.from(thead.querySelectorAll(common_constants_1.BcCommonConstants.TH_TAG));
        thCells.forEach(function (cell) {
            cell.classList.remove(bc_data_table_constants_1.BcDataTableConstansts.ORDER_ASC_CLASS);
            cell.classList.remove(bc_data_table_constants_1.BcDataTableConstansts.ORDER_DES_CLASS);
        });
    };
    BcDataTableColumnHeaderBehavior.prototype.cleanSortState = function (index) {
        var currentSort = this.bcDataTableColumnHeader.data[index].sort;
        var newSortStatus = currentSort === 'asc' || currentSort === null ? 'des' : 'asc';
        this.bcDataTableColumnHeader.data.forEach(function (element, elementIndex) {
            element.sort = null;
        });
        this.bcDataTableColumnHeader.data[index].sort = newSortStatus;
        return newSortStatus;
    };
    return BcDataTableColumnHeaderBehavior;
}());
exports.BcDataTableColumnHeaderBehavior = BcDataTableColumnHeaderBehavior;
